import { render, staticRenderFns } from "./breadcrum.vue?vue&type=template&id=96c3db28&scoped=true"
import script from "./breadcrum.vue?vue&type=script&lang=js"
export * from "./breadcrum.vue?vue&type=script&lang=js"
import style0 from "./breadcrum.vue?vue&type=style&index=0&id=96c3db28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c3db28",
  null
  
)

export default component.exports